import React, { useEffect, useRef } from "react";

/**
 * Barra fina en lo alto de la página que indica cuánto se ha leído.
 *
 * Escribe directamente sobre el `style` del nodo en vez de pasar por el estado:
 * el scroll dispara muchísimos eventos y un re-render por cada uno sería
 * desperdiciar trabajo. Se apoya en `requestAnimationFrame` para no leer el
 * layout más de una vez por fotograma.
 *
 * @returns {JSX.Element}
 */
const ReadingProgress = () => {
  const barraRef = useRef(null);

  useEffect(() => {
    let pendiente = false;

    const actualizar = () => {
      pendiente = false;
      const nodo = barraRef.current;
      if (!nodo) {
        return;
      }
      const recorrible = document.documentElement.scrollHeight - window.innerHeight;
      const avance = recorrible > 0 ? Math.min(window.scrollY / recorrible, 1) : 0;
      nodo.style.transform = `scaleX(${avance})`;
    };

    const alHacerScroll = () => {
      if (!pendiente) {
        pendiente = true;
        requestAnimationFrame(actualizar);
      }
    };

    actualizar();
    window.addEventListener("scroll", alHacerScroll, { passive: true });
    window.addEventListener("resize", alHacerScroll);

    return () => {
      window.removeEventListener("scroll", alHacerScroll);
      window.removeEventListener("resize", alHacerScroll);
    };
  }, []);

  return <div aria-hidden="true" className="progreso-lectura" ref={barraRef} style={{ transform: "scaleX(0)" }} />;
};

export default ReadingProgress;
